<template>
  <w-popup-show :state="state" @handleClose="handleClose">
    <div slot="content" class="mailing-content">

      <div class="mailing-header">
        <h6 class="mailing-header-title">
          选择想要投递的简历
        </h6>
        <p v-if="liveToken" class="mailing-header-subtitle">
          本场直播可投 <span>{{ liveDetailData.max_delivery_count }}个</span> 职位，当前还可投 <span>{{ liveDetailData.max_delivery_count - liveDelivryList.length }}个</span> 职位
        </p>
      </div>

      <div class="mailing-cv-list">

        <div class="more-cv-container" v-if="cvData.length > 0"
             :class="[cvData.length === 3 ? 'more-cv-container-2' : cvData.length > 3 ? 'more-cv-container-3' : '']">
          <cube-scroll :data="cvData" ref="scroll">

            <div class="flex-between mailing-item mailing-first" v-if="cvData.length" @click="selectCv(0, cvData[0])">
              <div class="flex-column cv-info-container">
                <p class="cv-info flex-start">
                  <span :class="cvData[0].modal_text ? 'cv-grey-name' : 'cv-name'">{{ cvData[0].name }}</span>
                  <span :class="cvData[0].modal_text ? 'cv-grey' : 'cv-score'">{{ cvData[0].score }}分</span>
                  <!-- <span class="cv-online" v-if="cvData[0].online">在线简历</span> -->
                  <!-- <span :class="cvData[0].modal_text ? 'cv-grey' : 'cv-score'">{{ cvData[0].lang }}</span> -->
                  <span v-if="cvData[0].online" :class="cvData[0].modal_text ? 'cv-grey' : 'cv-lang'">在线简历</span>
                  <span v-else :class="cvData[0].modal_text ? 'cv-grey' : 'cv-lang'">{{ cvData[0].lang }}</span>
                </p>
                <p class="cv-time">更新于 {{ cvData[0].update_at }}</p>
              </div>
              <input type="radio" class="radio-fit flex-center mailing-radio" :class="liveToken && 'live'" name="onlineCv" :checked="checkedIndex === 0">
            </div>

            <template v-for="(item,index) in cvData">
              <div :key="index" class="flex-between mailing-item" v-if="index > 0" @click="selectCv(index, item)">
                <div class="flex-column cv-info-container">
                  <p class="cv-info flex-start">
                    <span :class="item.modal_text ? 'cv-grey-name' : 'cv-name'">{{ item.name }}</span>
                    <span :class="item.modal_text ? 'cv-grey' : 'cv-score'">{{ item.score }}分</span>
                    <span v-if="item.online" :class="item.modal_text ? 'cv-grey' : 'cv-lang'">在线简历</span>
                    <span v-else :class="item.modal_text ? 'cv-grey' : 'cv-lang'">{{ item.lang }}</span>
                  </p>
                  <p class="cv-time">更新于 {{ item.update_at }}</p>
                </div>
                <input type="radio" class="radio-fit flex-center mailing-radio" :class="liveToken && 'live'" name="onlineCv"
                       :checked="checkedIndex === index">
              </div>
            </template>
          </cube-scroll>
        </div>

      </div>

      <div class="mailing-footer flex-column">
        <button class="theme-button footer-btn flex-center" :class="liveToken && 'live'" @click="sendMailing">立即投递</button>
      </div>

    </div>
  </w-popup-show>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import WPopupShow from '../../components/global/w-popup-show'

	export default {
		name: 'job-mailing',
		props: {
			state: {
				type: Boolean,
				default: false
			},
			cvData: {
				type: Array,
				default: () => []
			},
			onlineCheckState: {
				type: Boolean,
				default: false
			},
      cvAccountToken: {
				type: String,
        default: ''
      },
      liveToken: {
        type: String
      }
		},
		data () {
			return {
				checkedIndex: 0,
				moreState: false,
				boxChecked: false
			}
		},
		mounted () {
			this.initChecked()
		},
		computed: {
      ...mapState('live', [ 'liveDetailData', 'liveDelivryList' ])
    },
		watch: {},
		components: {
			WPopupShow
		},
		methods: {
			sendMailing () {
        if (this.cvData[this.checkedIndex].modal_text) {
          let text = this.cvData[this.checkedIndex].modal_text.error_msg_text || this.cvData[this.checkedIndex].modal_text.content || '简历信息不完整，请完善';
          this.toast = this.$createToast({
            txt: text,
            type: 'txt'
          })
          this.toast.show();
          return;
        } else {
          this.$emit('sendMailing', this.cvData[this.checkedIndex].token, this.boxChecked, this.checkedIndex)
        }
			},
			selectCv (index, item) {
        if (item.modal_text) {
          let text = item.modal_text.error_msg_text || item.modal_text.content || '简历信息不完整，请完善';
          this.toast = this.$createToast({
            txt: text,
            type: 'txt'
          })
          this.toast.show();
          return;
        } else {
          this.checkedIndex = index
        }
			},
			changeMoreState () {
				this.moreState = !this.moreState
			},
			handleClose () {
				this.$emit('handleClose')
			},
			initChecked () {
				let mailingChecked = this.$db.ls.get(`${ this.cvAccountToken }-mailing-checked`)
        if (!mailingChecked && this.onlineCheckState) this.boxChecked = true
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  .mailing-content {
    position: relative;
    width: 100vw;
    background: #F4F5F9;
    border-radius: 24px 24px 0 0;
    .mailing-header {
      padding: 32px 24px 24px 24px;
      border-radius: 24px 24px 0 0;

      .mailing-header-title {
        font-size: 18px;
        font-weight: 500;
        color: #404040;
        line-height: 18px;
      }

      .mailing-header-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: #8D99AA;
        line-height: 14px;
        margin-top: 10px;

        >span {
          font-weight: 600;
        }
      }
    }
    .mailing-cv-list {
      padding: 0 24px;
      .more-cv {
        padding: 16px 24px;
        margin-top: 6px;
        background-color: $color-light;
        color: #9C9C9C;
        line-height: 20px;
        .iconfont {
          font-weight: bold;
          font-size: 18px;
          color: #D9D9D9;
        }
      }
      .more-cv-container {
        // height: 94px;
      }
      .more-cv-container-2 {
        // height: 168px;
      }
      .more-cv-container-3 {
        height: 424px;
      }
      .mailing-item {
        padding: 16px 20px;
        // height: 74px;
        background: #FFFFFF;
        align-items: center;
        border-radius: 8px;
        margin-bottom: 10px;
        &:last-child {

        }
        .cv-info {
          margin-bottom: 4px;
          .cv-name, .cv-grey-name {
            line-height: 22px;
            max-width: 154px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 18px;
            font-size: 14;
            font-weight: 500;
          }
          .cv-grey-name {
            color: #9C9C9C;
          }
          .cv-score, .cv-lang, .cv-online, .cv-grey {
            background-color: rgba($color: $color-theme, $alpha: 0.08);
            color: #FF4F4C;
            border-radius: 2px;
            font-size: $font-size-small;
            padding: 4px;
            margin-right: 6px;
          }
          .cv-online {
            background-color: rgba($color: #4183FF, $alpha: 0.08);
            color: #4183FF;
          }
          .cv-lang {
            background-color: #d5e8fe;
            color: #4183FF;
          }
          .cv-grey {
            background: #F4F4F4;
            color: #9C9C9C;
          }
        }
        .cv-time {
          font-size: 12px;
          color: #9C9C9C;
          font-weight: 400;
        }
      }
      .mailing-first {
        margin-bottom: 10px;

        .cv-name {
          max-width: 138px !important;
        }
      }
      .mailing-radio {
        border-color: #BCBCBC !important;
        margin-right: 2px;
        &:before {
          width: 4px;
          height: 7px;
          bottom: 6px;
          left: 6px;
        }
        &:checked {
          border-color: #ffffff !important;
        }
        &.live {
          &::after {
            background-color: #4183FF;
          }
        }
      }
    }
    .mailing-footer {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 34px;
      padding: 0 24px;
      z-index: 99;
      .footer-btn {
        width: calc(100vw - 48px);
        height: 48px;
        border-radius: 24px;
        font-size: $font-size-medium-x;
        /*margin-bottom: 24px;*/
        background-color: #FF6644;

        &.live {
          background-color: #4183FF;
        }
      }
      .online-check {
        padding: 14px 0;
        .check-text {
          flex: 1;
          color: $color-dark-gray;
          font-size: $font-size-small;
        }
      }
    }
  }
  ::v-deep {
    .cube-scroll-list-wrapper {
      padding-bottom: 100px;
    }
  }
</style>
